import { makeApiUrl, makeHttpClient } from 'main/factories/http';
import { UpdateOrgUnit as UsecaseRemoteUpdateOrgUnit } from 'domain/usecases/orgUnit/remote';
// import { UpdateOrgUnit as UsecaseReduxUpdateOrgUnit } from 'domain/usecases/orgUnit/redux';

import { RemoteUpdateOrgUnit } from 'data/repository/orgUnit';
// import { ReduxUpdateOrgUnit } from 'data/store/reducer/orgUnit/usecases';

/**
 * send request via API.
 */
export const makeRemoteUpdateOrgUnit = (): UsecaseRemoteUpdateOrgUnit =>
  new RemoteUpdateOrgUnit(
    makeApiUrl('/orgs/{orgId}/units/{unitId}/'),
    makeHttpClient(),
  );

/**
 * send request via REDUX.
 */
/* export const makeReduxUpdateOrgUnit =
  (): UsecaseReduxUpdateOrgUnit =>
    new ReduxUpdateOrgUnit(); */
